// ACTION TYPES
const name = 'params';
export const actionTypes = {
  SET_API_URL: `${name}:set_api_url`,
};

// ACTIONS
export function setApiUrl(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_API_URL, value: param });
  };
}
